import { BusinessProfileUpdateStrategy } from '../../../../providers/BusinessProfileProvider';

export default {
  modals: {
    update_strategy: {
      title: 'Quali sedi devono essere aggiornate?',
      form: {
        update_strategy: {
          options: {
            [BusinessProfileUpdateStrategy.All]: 'Tutte le mie sedi',
            [BusinessProfileUpdateStrategy.Current]: 'Solo la sede selezionata',
          },
        },
      },
      buttons: {
        confirm: 'Conferma',
      },
    },
  },
  toasts: {
    error: 'Si è verificato un errore, riprova o contatta il supporto tecnico',
    success: 'Le modifiche sono state salvate con successo!',
  },
};
